module.exports = __webpack_public_path__ + "img/BAU Seniors_15.b5a9f94a.jpg";